// app/javascript/disable_autocomplete.js

document.addEventListener("turbo:load", () => {

  const selectors = [
    "input[type=text]",
    "input[type=number]",
    "input[type=email]",
    "input[type=tel]",
    "input[type=password]",
    "textarea"
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.setAttribute("autocomplete", "off");
    });
  });
});
